import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, exhaustMap, filter, map, mergeMap, switchMap} from 'rxjs/operators';
import {
    actionAccountCommandsFailure,
    actionAccountCommandsRequest,
    actionAccountCommandsSuccessV2,
    actionAccountPollLiveChatReply,
    actionAccountPollLiveChatRequest,
    actionAccountPollLiveChatV2Reply,
    actionAccountPollLiveChatV2Request,
    actionAccountSendEmail,
    actionAccountSendEmailDone,
    actionAccountSocialLoginFailure,
    actionAccountSocialLoginReply,
    actionAccountSocialLoginRequest,
    actionAddUserReply,
    actionAddUserRequest,
    actionCreateCredentialsLdapReply,
    actionCreditCardPaymentCompleted,
    actionCRUDRecord,
    actionCRUDRecordFailure,
    actionCRUDRecordSuccess,
    actionCustomerUpgradeReply,
    actionCustomerUpgradeRequest,
    actionCustomUrl,
    actionCustomUrlReply,
    actionMonitorMintTokenRequest,
    actionMonitorMintTokenReply,
    actionMonitorMintTokenFailure,
    actionMonitorRedeemTokenRequest,
    actionMonitorRedeemTokenReply,
    actionMonitorRedeemTokenFailure,
    actionMonitorPostEventsRequest,
    actionMonitorPostEventsReply,
    actionMonitorPostEventsFailure,
    actionMonitorRefreshIdentitiesRequest,
    actionMonitorRefreshIdentitiesReply,
    actionMonitorRefreshIdentitiesFailure,
    actionMonitorGetFeedRequest,
    actionMonitorGetFeedReply,
    actionMonitorGetFeedFailure,
    actionMonitorGetHistoryRequest,
    actionMonitorGetHistoryReply,
    actionMonitorGetHistoryFailure,
    actionMonitorAckRequest,
    actionMonitorAckReply,
    actionMonitorAckFailure,
    actionMonitorStreamTicketRequest,
    actionMonitorStreamTicketReply,
    actionMonitorStreamTicketFailure,
    actionMonitorGetConfigRequest,
    actionMonitorGetConfigReply,
    actionMonitorGetConfigFailure,
    actionMonitorPutConfigRequest,
    actionMonitorPutConfigReply,
    actionMonitorPutConfigFailure,
    actionMonitorGetStatesRequest,
    actionMonitorGetStatesReply,
    actionMonitorGetStatesFailure,
    actionMonitorServiceGetConfigRequest,
    actionMonitorServiceGetConfigReply,
    actionMonitorServiceGetConfigFailure,
    actionMonitorServiceSetConfigRequest,
    actionMonitorServiceSetConfigReply,
    actionMonitorServiceSetConfigFailure,
    actionMonitorServiceAddStationRequest,
    actionMonitorServiceAddStationReply,
    actionMonitorServiceAddStationFailure,
    actionMonitorServiceRemoveStationRequest,
    actionMonitorServiceRemoveStationReply,
    actionMonitorServiceRemoveStationFailure,
    actionDeleteUserReply,
    actionDeleteUserRequest,
    actionDetachFromResellerReply,
    actionDetachFromResellerRequest,
    actionDynawebsBusinessUsage,
    actionDynawebsBusinessUsageReply,
    actionDynawebsCheckUser,
    actionDynawebsCheckUserSuccess,
    actionDynawebsCreateNewOrder,
    actionDynawebsCreateNewOrderSuccess,
    actionDynawebsDeleteOrder,
    actionDynawebsDeleteOrderCompleted,
    actionDynawebsFindCustomer,
    actionDynawebsFindCustomerSuccess,
    actionDynawebsFindOrder,
    actionDynawebsFindOrderSuccess,
    actionDynawebsGenerateEncryptedIdReply,
    actionDynawebsGenerateEncryptedIdRequest,
    actionDynawebsGetAccDetails,
    actionDynawebsGetAccDetailsReply,
    actionDynawebsGetNonPayerReport,
    actionDynawebsGetNonPayerReportReply,
    actionDynawebsGetPayerReport,
    actionDynawebsGetPayerReportReply,
    actionDynawebsGetPayerReports,
    actionDynawebsGetPayerReportsReply,
    actionDynawebsOrderStatus,
    actionDynawebsOrderStatusSuccess,
    actionDynawebsRenameCustomer,
    actionDynawebsRenameCustomerSuccess,
    actionDynawebsSaveServer,
    actionDynawebsSearchServer,
    actionDynawebsServerSuccess,
    actionGetAccountDetails,
    actionGetAccountDetailsBillingToken,
    actionGetAIImage,
    actionGetAIImageReply,
    actionGetAIImages,
    actionGetAIImagesReply,
    actionGetAIImagesV5,
    actionGetAIImagesV5Reply,
    actionGetAIImagesV5Failure,
    actionGetAIVideo,
    actionGetAIVideoReply,
    actionPollVideoStatus,
    actionPollVideoStatusReply,
    actionFeedMeAnyRequest,
    actionFeedMeAnySuccess,
    actionFeedMeAnyFailure,
    actionGetAnnualPayError,
    actionGetAnnualPayReply,
    actionGetAnnualPayRequest,
    actionGetBillingInfoReply,
    actionGetBillingInfoRequest,
    actionGetCustomerUsersReply,
    actionGetCustomerUsersRequest,
    actionGetLocalStorageConfigServer,
    actionGetLocalStorageConfigServerReply,
    actionGetOrderIdRequest,
    actionGetOrderIdSuccess,
    actionGetPayerLinkReply,
    actionGetPayerLinkRequest,
    actionGetPaymentsReply,
    actionGetPaymentsRequest,
    actionGetResellerCustomersReply,
    actionGetResellerCustomersRequest,
    actionGetResourcesSharedLibrary,
    actionGetResourcesSharedLibrarySuccess,
    actionGetSharedCommonContent,
    actionGetSharedCommonContentReply,
    actionLoadAccountFailure,
    actionLoadAccountRequest,
    actionLoadAccountSuccess,
    actionLoadCartContentRequest,
    actionLoadCartContentSuccess,
    actionLoadCartFailure,
    actionLoadCartPaypalTokenSuccess,
    actionLoadCartProductRequest,
    actionLoadCartProductsSuccess,
    actionLoadDynawebsCart,
    actionLoadDynawebsCartProductRequest,
    actionLoadDynawebsCartProductsSuccess,
    actionLoadDynawebsCartReply,
    actionLoadDynawebsCartUpdateSuccess,
    actionLoadDynawebsEquipment,
    actionLoadDynawebsEquipmentReply,
    actionLoadDynawebsOrder,
    actionLoadDynawebsOrderReply,
    actionLoadOrderRequest,
    actionLoadOrdersFailure,
    actionLoadOrdersRequest,
    actionLoadOrdersSuccess,
    actionLoadOrderSuccess,
    actionLoadStationFailure,
    actionLoadStationGeoIPFailure,
    actionLoadStationGeoIPRequest,
    actionLoadStationRequest,
    actionLoadStationsGeoIPSuccess,
    actionLoadStationStatistic,
    actionLoadStationStatisticReply,
    actionLoadStationV2LogClear,
    actionLoadStationV2LogClearReply,
    actionLoadStationV2LogReply,
    actionLoadStationV2LogRequest,
    actionLoadTemplateFailure,
    actionLoadTemplateRequest,
    actionLoadTemplatesSuccess,
    actionLoginViewMode,
    actionNoop,
    actionPaymentDeleteReply,
    actionPaymentDeleteRequest,
    actionPaymentDetailsReply,
    actionPaymentDetailsRequest,
    actionPaymentsReportReply,
    actionPaymentsReportRequest,
    actionPaymentUpdateReply,
    actionPaymentUpdateRequest,
    actionPostChatArchive,
    actionPostChatArchiveFailed,
    actionPostChatArchiveReply,
    actionPostChatArchiveSearch,
    actionPostChatArchiveSearchReply,
    actionPostChatStats,
    actionPostChatStatsSuccess,
    actionPreferencesError,
    actionPreferencesGet,
    actionPreferenceUpdateStore,
    actionSelfUpgradeEligibleRequest,
    actionSelfUpgradeEligibleReply,
    actionPreloginResellerFailed,
    actionPreloginResellerReply,
    actionPreloginResellerRequest,
    actionRecurringsReply,
    actionRequrringsRequest,
    actionGetWebPlayersReply,
    actionGetWebPlayersRequest,
    actionGetResellerAuditReply,
    actionGetResellerAuditRequest,
    actionGetStationsHistoryReply,
    actionGetStationsHistoryRequest,
    actionRestartAllStationsReply,
    actionRestartAllStationsRequest,
    actionSaveCustomerDynawebsError,
    actionSaveCustomerDynawebsInfo,
    actionSaveCustomerDynawebsReply,
    actionSaveCustomerError,
    actionSaveCustomerReply,
    actionSaveCustomerRequest,
    actionSaveDynawebsEquipment,
    actionSaveDynawebsEquipmentSuccess,
    actionSaveFailedDynawebsEquipment,
    actionSetGlobalConfigReply,
    actionSetLocalStorageConfig,
    actionSocialCreateError,
    actionSocialCreateKey,
    actionSocialCreateSuccess,
    actionSocialCreateURL,
    actionSocialCreateURLSuccess,
    actionSocialPost,
    actionSocialPostSuccess,
    actionSocialRemoveKey,
    actionSocialRemoveKeyError,
    actionSocialRemoveKeySuccess,
    actionSocialRemoveKeyWithBusinessId,
    actionCanvaAuthorizeRequest,
    actionCanvaAuthorizeSuccess,
    actionCanvaAuthorizeFailure,
    actionCanvaGetRefIdRequest,
    actionCanvaGetRefIdSuccess,
    actionCanvaGetRefIdFailure,
    actionCanvaRevokeRequest,
    actionCanvaRevokeSuccess,
    actionCanvaRevokeFailure,
    actionSocialRemoveKeyWithBusinessIdSuccess,
    actionStationV1V2Update,
    actionTextToSpeechCreateReply,
    actionTextToSpeechCreateSend,
    actionTextToSpeechUploadError,
    actionTextToSpeechUploadReply,
    actionTextToSpeechUploadSend,
    actionDynawebsSetStudioTypeSend,
    actionDynawebsSetStudioTypeReply,
    actionDynawebsSetStudioTypeError,
    actionDynawebsRevertMigrationSend,
    actionDynawebsRevertMigrationReply,
    actionDynawebsRevertMigrationError,
    actionDynawebsGetMigratedAccountsSend,
    actionDynawebsGetMigratedAccountsReply,
    actionDynawebsGetMigratedAccountsError,
    actionDynawebsMoveAccountSend,
    actionDynawebsMoveAccountReply,
    actionDynawebsMoveAccountError,
    actionDwGetStoppedPlayersRequest,
    actionDwGetStoppedPlayersReply,
    actionDwGetStoppedPlayersFailure,
    actionDwSaveStoppedPlayersRequest,
    actionDwSaveStoppedPlayersReply,
    actionDwSaveStoppedPlayersFailure,
    actionFreeLoadersRunSearch,
    actionFreeLoadersRunSearchReply,
    actionFreeLoadersRunSearchError,
    actionFreeLoadersRunIP,
    actionFreeLoadersRunIPReply,
    actionFreeLoadersRunIPError,
    actionFreeLoadersDomainRun,
    actionFreeLoadersDomainRunReply,
    actionFreeLoadersDomainRunError,
    actionFreeLoadersStatus,
    actionFreeLoadersStatusReply,
    actionFreeLoadersStatusError,
    actionDynawebsAwakeSet,
    actionDynawebsAwakeSetReply,
    actionDynawebsAwakeSetError,
    actionDynawebsAwakeGet,
    actionDynawebsAwakeGetReply,
    actionDynawebsAwakeGetError,
    actionTwoFactorAuth,
    actionTwoFactorAuthError,
    actionTwoFactorAuthReply,
    actionTwoFactorCheckAccess,
    actionTwoFactorGen,
    actionTwoFactorGenError,
    actionTwoFactorGenReply,
    actionUpdateAccountDetails,
    actionUpdateAnnualPay,
    actionUpdateAnnualPayReply,
    actionUpdateBillingInfoReply,
    actionUpdateBillingInfoRequest,
    actionUpdateCartShippingSuccess,
    actionUpdateCustomerEmail,
    actionUpdateRecurringsReply,
    actionUpdateRequrringsRequest,
    actionUpdateResellerReply,
    actionUpdateResellerRequest,
    actionUploadFiles,
    actionUploadFilesReply,
    actionUserUpgradeFailed,
    actionUserUpgradeReply,
    actionUserUpgradeRequest,
    actionPexelsSearchPhotos,
    actionPexelsSearchPhotosReply,
    actionPexelsSearchVideos,
    actionPexelsSearchVideosReply,
    actionGenerateAISceneRequest,
    actionGenerateAISceneReply,
    actionPingStationRequest,
    actionPingStationReply,
    actionPingStationFailure,
    actionGenerateAISceneFailure,
    actionRefineAISceneRequest,
    actionRefineAISceneReply,
    actionRefineAISceneFailure,
    actionGenerateAISceneVariationsRequest,
    actionGenerateAISceneVariationsReply,
    actionGenerateAISceneVariationsFailure,
    actionGenerateAIPaintRequest,
    actionGenerateAIPaintReply,
    actionGenerateAIPaintFailure,
    actionRemotionVideoRequest,
    actionRemotionVideoReply,
    actionRemotionVideoFailure,
    actionRemotionVideoStatusRequest,
    actionRemotionVideoStatusReply,
    actionRemotionVideoStatusFailure,
    actionRemotionVideoEditRequest,
    actionRemotionVideoEditReply,
    actionRemotionVideoEditFailure,
    actionFeedFieldsRequest,
    actionFeedFieldsSuccess,
    actionFeedFieldsFailure,
    actionCreateTicketRequest,
    actionCreateTicketReply,
    actionCreateTicketFailure,
    actionGetTicketsRequest,
    actionGetTicketsReply,
    actionGetTicketsFailure,
    actionGetTicketRequest,
    actionGetTicketReply,
    actionGetTicketFailure,
    actionUpdateTicketRequest,
    actionUpdateTicketReply,
    actionUpdateTicketFailure,
    actionAddTicketMessageRequest,
    actionAddTicketMessageReply,
    actionAddTicketMessageFailure,
    actionCloseTicketRequest,
    actionCloseTicketReply,
    actionCloseTicketFailure,
    actionGetTicketStatsRequest,
    actionGetTicketStatsReply,
    actionGetTicketStatsFailure,
    actionGetCustomerTicketRequest,
    actionGetCustomerTicketReply,
    actionGetCustomerTicketFailure,
    actionAddCustomerTicketMessageRequest,
    actionAddCustomerTicketMessageReply,
    actionAddCustomerTicketMessageFailure,
    actionGetCannedResponsesRequest,
    actionGetCannedResponsesReply,
    actionGetCannedResponsesFailure,
    actionAddCannedResponseRequest,
    actionAddCannedResponseReply,
    actionAddCannedResponseFailure,
    actionUpdateCannedResponseRequest,
    actionUpdateCannedResponseReply,
    actionUpdateCannedResponseFailure,
    actionDeleteCannedResponseRequest,
    actionDeleteCannedResponseReply,
    actionDeleteCannedResponseFailure
} from '../actions/user.actions';
import {BusinessId, directionType, EnumLoginViewMode, IAccountReplyV2, IAccountRequest, IAppStatic, ICartReply, ICartRequest, ICRUDRecordReply, IFeedFieldsResponse, IFeedMeAnyResponse, IOrderDetails, IOrderForm, IPreferencesBusiness, ISharedContent, ISharedResourceLibrary, ISocialReply, IUserSaveDetailsReply, IUserSync, IUserUpgradeReply, UploadStatus} from "../../interfaces";
import {ToastrService} from "ngx-toastr";
import {AuthUserService, LocalStoreService, StoreSelectorsService, UserService} from "../../services";
import {IAmazonLogin, ISocialServerReply} from "../../interfaces/social-interface";
import {LoginForm} from "../../models";
import {Router} from "@angular/router";
import {Lib} from "../../../libs/Lib";
import {TranslocoService} from "@ngneat/transloco";
import {IAccountDetails} from "../../interfaces/enterprise-account-interface";
import {isGalaxy, isNullOrUndefOrEmpty, NONE_VALUE} from "../../common";
import {IChatServerReply} from "../../interfaces/chat-interface";

@Injectable()
export class UserEffects {

    private _twoFactorCheckDispatched = false;

    loadRequestEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadAccountRequest),
            map((action: any) => action),
            switchMap((i_action) =>
                this.userService.getUserScenesData(i_action.businessId, i_action.changelistId).pipe(
                    map((i_payload: any) => {
                        if (i_action.changelistId !== NONE_VALUE && !isGalaxy()) {
                            // this.toastr.warning(this.translocoService.translate('toast.userSync3', {}, this.translocoService.getActiveLang()));
                            Lib.DevShow('Studio data was changed so updating configuration');
                        }
                        return actionLoadAccountSuccess({accountData: i_payload, changelistId: i_action.changelistId});
                    }),
                    catchError((i_error) => {
                        if (Lib.DevMode()) {
                            this.toastr.error(`Dev mode: problem parsing loadData db fields ${i_error.message}`);
                        }
                        Lib.DevShow(`Problem parsing loadData: loadRequestEffect$ ${i_error.message}`);
                        if (Lib.DevMode()) {
                            alert(`Problem parsing loadData: loadRequestEffect$ ${i_error.message}`);
                        }
                        return of(actionLoadAccountFailure({errorMessage: i_error.message, scenes: []}));
                    })
                )
            )
        )
    );

    loadResourcesLibraryEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetResourcesSharedLibrary),
            map((action) => action),
            switchMap((v) =>
                this.userService.getSharedResourcesLibrary(v.config).pipe(
                    map((i_payload: ISharedResourceLibrary) => actionGetResourcesSharedLibrarySuccess({value: i_payload})),
                    catchError((i_error) => {
                        console.log(`loadRequestResourcesLibraryEffect$ ${i_error.message}`);
                        return of(actionLoadAccountFailure({errorMessage: i_error.message, stationArray: []}));
                    })
                )
            )
        )
    );

    /** load station stats for version 1 type stations (version 2 uses wss:// ...) **/
    loadRequestStationV1Effect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadStationRequest),
            map((action) => action.businessId),
            switchMap((i_businessId: BusinessId) =>
                this.userService.getUserStationData(i_businessId).pipe(
                    map((i_payload: any) => {
                        return actionStationV1V2Update({stationArray: i_payload});
                    }),
                    catchError((i_error) => {
                        console.log(`loadRequestStationEffect$ ${i_error.message}`);
                        return of(actionLoadStationFailure({errorMessage: i_error.message, stationArray: []}));
                    })
                )
            )
        )
    );

    loadRequestStationV2LogEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadStationV2LogRequest),
            map((action) => action.payload),
            switchMap((i_payload) =>
                this.userService.getUserStationLog(i_payload).pipe(
                    map((reply) => {
                        return actionLoadStationV2LogReply(reply);
                    }),
                    catchError((i_error) => {
                        console.log(`loadRequestStationEffect$ ${i_error.message}`);
                        return of(actionLoadStationFailure({errorMessage: i_error.message, stationArray: []}));
                    })
                )
            )
        )
    );

    loadRequestStationStatisticEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadStationStatistic),
            map((action) => action.payload),
            switchMap((i_payload) =>
                this.userService.getUserStationStatistic(i_payload).pipe(
                    map((reply) => {
                        return actionLoadStationStatisticReply(reply);
                    }),
                    catchError((i_error) => {
                        console.log(`loadRequestStationStatisticEffect$ ${i_error.message}`);
                        return of(actionLoadStationStatisticReply(null));
                    })
                )
            )
        )
    );

    loadRequestStationV2LogClearEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadStationV2LogClear),
            map((action) => action.payload),
            switchMap((i_payload) =>
                this.userService.getUserStationClearLog(i_payload).pipe(
                    map((reply) => {
                        return actionLoadStationV2LogClearReply(reply);
                    }),
                    catchError((i_error) => {
                        console.log(`loadRequestStationEffect$ ${i_error.message}`);
                        return of(actionLoadStationFailure({errorMessage: i_error.message, stationArray: []}));
                    })
                )
            )
        )
    );

    // loadRequestStationTrackEffect$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(actionLoadTrackingStationRequest),
    //         map((action) => action),
    //         switchMap((v) =>
    //             this.userService.getGlobalServiceData('getStationTracking', {noBody: true}, true).pipe(
    //                 map((i_payload: IStationTrackReply[]) => {
    //                     return actionLoadTrackingStationSuccess({stationTrackReply: i_payload});
    //                 }),
    //                 catchError((i_error) => {
    //                     console.log(`loadRequestStationTrackEffect$ ${i_error.message}`);
    //                     return of(actionLoadTrackingStationFailure({errorMessage: i_error.message, stationArray: []}));
    //                 })
    //             )
    //         )
    //     )
    // );

    // loadRequestStationTrackStatsEffect$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(actionLoadTrackingStationStatsRequest),
    //         map((action) => action),
    //         switchMap((v) =>
    //             this.userService.getGlobalServiceData('getStationTrackingStats', {noBody: true}, true).pipe(
    //                 map((i_payload: IStationTrackReply[]) => {
    //                     return actionLoadTrackingStationStatsSuccess({stationTrackReply: i_payload});
    //                 }),
    //                 catchError((i_error) => {
    //                     console.log(`loadRequestStationTrackEffect$ ${i_error.message}`);
    //                     return of(actionLoadTrackingStationFailure({errorMessage: i_error.message, stationArray: []}));
    //                 })
    //             )
    //         )
    //     )
    // );

    checkLoginSocialToken$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionAccountSocialLoginRequest),
            map((action) => action.payload),
            filter(v => v != null),
            switchMap((i_data) =>
                this.userService.verifySocialToken(i_data).pipe(
                    map((i_payload: ISocialServerReply | IAmazonLogin | any) => {

                        // Amazon 3-25-2024
                        // i_payload = {
                        //     "socialUser": {
                        //         "idToken": {
                        //             "access": {
                        //                 "user_id": "XX",
                        //                 "name": "Shachar Sean Levy",
                        //                 "email": "born2net@gmail.com"
                        //             }, "isReseller": false, "msUser": "bort@abv.com", "msPassword": "TTTTT", "exists": true
                        //         },
                        //         "provider": "AMAZON",
                        //         "id": "XX",
                        //         "email": "born2net@gmail.com",
                        //         "name": "Shachar Sean Levy",
                        //         "photoUrl": "http://www.www.jpg",
                        //         "firstName": "Shachar"
                        //     },
                        //     "profile": {"access": {"user": "aa", "name": "dd Sean dd", "company": ""}},
                        //     "isReseller": null,
                        //     "msUser": null,
                        //     "msPassword": null,
                        //     "exists": null
                        // };

                        // i_payload = {
                        //     "profile": {
                        //         "iss": "https://accounts.google.com",
                        //         "azp": "637219265100-r4jh7dppmcs1so7mr1jpvffmskke8mrm.apps.googleusercontent.com",
                        //         "aud": "637219265100-r4jh7dppmcs1so7mr1jpvffmskke8mrm.apps.googleusercontent.com",
                        //         "sub": "118307884438399953417",
                        //         "email": "abrahamlevyinv@gmail.com",
                        //         "email_verified": true,
                        //         "nbf": 1708947640,
                        //         "name": "abraham levy",
                        //         "picture": "https://lh3.googleusercontent.com/a/ACg8ocJV0Ipa6MMTfvjGoEkLY-LeK-ljj_Tr6_OQcBpxZJom=s96-c",
                        //         "given_name": "abraham",
                        //         "family_name": "levy",
                        //         "locale": "he",
                        //         "iat": 1708947940,
                        //         "exp": 1708951540,
                        //         "jti": "0ace60b61d6d37835b9548e6d7ad045876b43902"
                        //     },
                        //     "isReseller": false, "msUser": "abrahamlevyinv@gmail.com", "msPassword": "xbq9gyyi3hpezsuxnnuj1v", "exists": true
                        // };

                        if (i_payload.value && i_payload.value.provider) {
                            /****************************************/
                            /**             Facebook                 **/
                            /****************************************/
                            if (i_payload.exists) {
                                const model: LoginForm = new LoginForm();
                                model.username = i_payload.msUser;
                                model.password = i_payload.msPassword;
                                this.toastr.info(this.translocoService.translate('Facebook login...'));
                                this.authService.login(model, null);
                            } else {
                                this.authService.createUserSocial(i_payload);
                            }
                            return actionAccountSocialLoginReply({payload: i_payload});

                        } else if (i_payload.value && i_payload.value?.ldap) {
                            /****************************************/
                            /**              LDAP                   **/
                            /****************************************/
                            if (i_payload.exists) {
                                const model: LoginForm = new LoginForm();
                                model.username = i_payload.msUser;
                                model.password = i_payload.msPassword;
                                this.toastr.info(this.translocoService.translate('LDAP login...'));
                                this.authService.login(model, true);
                            } else {
                                this.authService.createUserSocial(i_payload);
                            }
                            return actionAccountSocialLoginReply({payload: i_payload});

                        } else if (i_payload?.socialUser?.idToken) {
                            /****************************************/
                            /**              Amazon               **/
                            /****************************************/
                            const amazonPayload: IAmazonLogin = i_payload;
                            if (amazonPayload.socialUser?.idToken?.exists) {
                                const model: LoginForm = new LoginForm();
                                model.username = amazonPayload.socialUser.idToken.msUser;
                                model.password = amazonPayload.socialUser.idToken.msPassword;
                                this.toastr.info(this.translocoService.translate('Amazon login...'));
                                this.authService.login(model, null);
                            } else {
                                this.authService.createUserSocial(amazonPayload);
                            }
                            return actionAccountSocialLoginReply({payload: i_payload});

                        } else if (i_payload?.profile?.iss || i_payload?.value?.iss) {
                            /****************************************/
                            /**              Google               **/
                            /****************************************/
                            if (i_payload.exists) {
                                const model: LoginForm = new LoginForm();
                                model.username = i_payload.msUser;
                                model.password = i_payload.msPassword;
                                this.toastr.info(this.translocoService.translate('Google login...'));
                                this.authService.login(model, null);
                            } else {
                                this.authService.createUserSocial(i_payload);
                                // this.router.navigateByUrl(`/getstarted/create`);
                            }
                            return actionAccountSocialLoginReply({payload: i_payload});


                        } else if (i_payload.message) {
                            this.toastr.error(this.translocoService.translate('toast.authFaceExpire', {}, this.translocoService.getActiveLang()));
                            this.storeSelectorsService.dispatch(actionLoginViewMode({loginViewMode: EnumLoginViewMode.LOGIN}));
                            actionAccountSocialLoginReply({payload: null});
                            return actionAccountSocialLoginFailure({errorMessage: 'expired'});

                        } else if (i_payload.status && i_payload.status === 'tooLate') {
                            this.toastr.error(this.translocoService.translate('toast.authGoogleExpire', {}, this.translocoService.getActiveLang()));
                            this.storeSelectorsService.dispatch(actionLoginViewMode({loginViewMode: EnumLoginViewMode.LOGIN}));
                            actionAccountSocialLoginReply({payload: null});
                            return actionAccountSocialLoginFailure({errorMessage: 'expired'});

                        } else {
                            this.toastr.error(this.translocoService.translate('toast.unknownSocial', {}, this.translocoService.getActiveLang()));
                            console.log('social error occured ' + JSON.stringify(i_payload));
                            this.storeSelectorsService.dispatch(actionLoginViewMode({loginViewMode: EnumLoginViewMode.LOGIN}));
                            actionAccountSocialLoginReply({payload: null});
                            return actionAccountSocialLoginFailure({errorMessage: 'expired'});
                        }
                    }),
                    catchError((i_error) => {
                        console.log(`checkLoginSocialToken$ ${i_error.message}`);
                        this.storeSelectorsService.dispatch(actionLoginViewMode({loginViewMode: EnumLoginViewMode.LOGIN}));
                        actionAccountSocialLoginReply({payload: null});
                        return of(actionAccountSocialLoginFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    // i_payload.forEach((order) => {
    //     order.id = _.uniqueId('generated_');
    // });

    loadRequestLiveChatEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionAccountPollLiveChatRequest),
            switchMap((val) => {
                return this.userService.liveChatStatus().pipe(
                    map((i_payload: any) => actionAccountPollLiveChatReply({liveChatStatus: i_payload})),
                    catchError((i_error) => {
                        console.log(`loadRequestLiveChatEffect$ ${i_error.message}`);
                        return of(actionLoadStationFailure({errorMessage: i_error.message, stationArray: null}));
                    })
                );
            })
        )
    );

    loadRequestLiveChatEffectV2$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionAccountPollLiveChatV2Request),
            switchMap((val: IChatServerReply) => {
                return this.userService.liveChatStatusV2().pipe(
                    map((i_reply) => {
                        return actionAccountPollLiveChatV2Reply({chatServerReply: i_reply});
                    }),
                    catchError((i_error) => {
                        console.log(`loadRequestLiveChatEffect$ ${i_error.message}`);
                        return of(actionLoadStationFailure({errorMessage: i_error.message, stationArray: null}));
                    })
                );
            })
        )
    );

    sendEmailEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionAccountSendEmail),
            switchMap((v) =>
                this.userService.sendEmail(v.emailSend).pipe(
                    map((i_payload: any) => actionAccountSendEmailDone({errorMessage: null})),
                    catchError((i_error) => {
                        console.log(`actionAccountSendEmail ${i_error.message}`);
                        return of(actionAccountSendEmailDone({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    crudRecordEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCRUDRecord),
            switchMap((v) =>
                this.userService.crudRecord(v.saveRecord).pipe(
                    map((i_reply: ICRUDRecordReply) => actionCRUDRecordSuccess({
                        saveRecord: {
                            studioId: null,
                            command: "reply",
                            body: i_reply,
                            serverReply: i_reply
                        }
                    })),
                    catchError((i_error) => {
                        console.log(`actionCRUDRecordFailure ${i_error.message}`);
                        return of(actionCRUDRecordFailure({
                            saveRecord: {
                                studioId: null,
                                command: "reply",
                                body: i_error,
                                serverReply: {status: false, id: null}
                            }
                        }));
                    })
                )
            )
        )
    );

    loadRequestOrdersEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadOrdersRequest),
            switchMap(() =>
                this.userService.getOrders().pipe(
                    map((i_payload: IOrderForm[]) => actionLoadOrdersSuccess({orders: i_payload})),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadRequestAccountDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetAccountDetails),
            switchMap(() =>
                this.userService.getAccountDetails().pipe(
                    map((i_payload: IAccountDetails) => {
                        if (i_payload.Account?.Billing?.[0]?.$?.xmlns === '' || i_payload?.Account?.Shipping?.[0]?.$?.xmlns === '') {
                            return actionNoop({});
                        }
                        return actionUpdateAccountDetails({userDetails: i_payload});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadRequestAccountDetailsBillingToken$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetAccountDetailsBillingToken),
            switchMap((v) =>
                this.userService.getAccountDetailsBillingToken(v).pipe(
                    map((i_payload: IAccountDetails) => {
                        return actionUpdateAccountDetails({userDetails: i_payload});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadRequestOrderEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadOrderRequest),
            switchMap((v) =>
                this.userService.getOrder(v.orderId).pipe(
                    map((i_payload: IOrderDetails) => actionLoadOrderSuccess({order: i_payload})),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadOrdersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadRequestStationGeoIPsEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadStationGeoIPRequest),
            switchMap(() =>
                this.userService.getServerStationsGeoIPs(false).pipe(
                    map((i_payload: any) => {
                        return actionLoadStationsGeoIPSuccess({stationArray: i_payload});
                    }),
                    catchError((i_error) => {
                        console.log(`loadRequestStationGeoIPsEffect$ ${i_error.message}`);
                        return of(actionLoadStationGeoIPFailure({errorMessage: i_error.message, stationArray: []}));
                    })
                )
            )
        )
    );

    loadResellerPreloginInfo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPreloginResellerRequest),
            switchMap((v) =>
                this.userService.dwPreloginGetResellerInfo(v.isWhitelabel).pipe(
                    map((i_payload: any) => {
                        return actionPreloginResellerReply({resellerInfo: i_payload});
                    }),
                    catchError((i_error) => {
                        console.log(`loadResellerPreloginInfo$ ${i_error.message}`);
                        return of(actionPreloginResellerFailed({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadRequestAccountEffect$ = createEffect(() =>
            this.actions$.pipe(
                ofType(actionAccountCommandsRequest),
                switchMap((val) => {
                    const accountRequest: IAccountRequest = val.accountRequest;
                    switch (accountRequest.serverCall) {
                        case "SYNC_USER":
                        case "STATION_MONITOR":
                        case "STATION_MONITOR_WALL":
                        case "VERIFY_V2": {
                            return this.userService.getBusinessUserInfoV3(accountRequest.verifyAccount.userName, accountRequest.verifyAccount.password).pipe(
                                map((i_payload: IUserSync) => {
                                    if (i_payload.status == 'fail') {
                                        this.authService.loginFailed();
                                        throw new Error('login failed...');
                                    }
                                    if (i_payload.accountReplyV2.businessUserInfo) {
                                        this.authService.loginSuccess(i_payload, accountRequest, accountRequest.serverCall);
                                        return actionAccountCommandsSuccessV2({accountReply: i_payload.accountReplyV2});
                                    }
                                    this.authService.loginFailed();
                                    throw new Error('login failed...');
                                }),
                                catchError((i_error) => {
                                    console.log(`loadRequestAccountEffect1$ ${i_error.message}`);
                                    return of(actionAccountCommandsFailure({errorMessage: i_error.message, accountReply: null}));
                                })
                            );
                        }
                        case "SUBSCRIBE_STANDALONE": {
                            return this.userService.getBusinessUserInfoV3('none', 'none', accountRequest.verifyAccount.password).pipe(
                                map((i_payload: IUserSync) => {
                                    this.toastr.clear();
                                    if (i_payload.status == 'fail') {
                                        this.authService.loginFailed();
                                        throw new Error('login failed...');
                                    }
                                    if (i_payload.accountReplyV2.businessUserInfo) {
                                        this.authService.loginSuccess(i_payload, accountRequest, accountRequest.serverCall);
                                        return actionAccountCommandsSuccessV2({accountReply: i_payload.accountReplyV2});
                                    }
                                    this.authService.loginFailed();
                                    throw new Error('login failed...');
                                }),
                                catchError((i_error) => {
                                    console.log(`loadRequestAccountEffect1$ ${i_error.message}`);
                                    return of(actionAccountCommandsFailure({errorMessage: i_error.message, accountReply: null}));
                                })
                            );
                        }
                        case "LDAP_AUTH": {
                            return this.userService.dwLdapAuth(accountRequest).pipe(
                                map((i_payload: IAccountReplyV2) => {
                                    this.toastr.clear();
                                    if (i_payload.result === 'fail') {
                                        this.toastr.error(this.translocoService.translate('account.loginFailed', {}, this.translocoService.getActiveLang()));
                                        throw new Error('could not auth ldap...');
                                    }
                                    return actionCreateCredentialsLdapReply({accountReply: i_payload});
                                }),
                                catchError((i_error) => {
                                    console.log(`loadRequestAccountEffect6$ ${i_error.message}`);
                                    return of(actionAccountCommandsFailure({errorMessage: i_error.message, accountReply: null}));
                                })
                            );
                        }
                        case "BUSINESS_RENAME": {
                            return this.userService.changeBusinessName(accountRequest).pipe(
                                map((i_payload: IAccountReplyV2) => {
                                    this.toastr.clear();
                                    if (i_payload.result != '1') {
                                        this.toastr.error(this.translocoService.translate('toast.probBusinessName', {}, this.translocoService.getActiveLang()));
                                        throw new Error('could not change business name...');
                                    }
                                    this.toastr.success(this.translocoService.translate('toast.businessNameChanged', {}, this.translocoService.getActiveLang()));
                                    this.authService.backToLogin();
                                    return actionAccountCommandsSuccessV2({accountReply: i_payload});
                                }),
                                catchError((i_error) => {
                                    console.log(`loadRequestAccountEffect2$ ${i_error.message}`);
                                    return of(actionAccountCommandsFailure({errorMessage: i_error.message, accountReply: null}));
                                })
                            );
                        }
                        case "CHANGE_PASS": {
                            return this.userService.changePassword(accountRequest).pipe(
                                map((i_payload: IAccountReplyV2) => {
                                    this.toastr.clear();
                                    if (i_payload.result != '1') {
                                        this.toastr.error(this.translocoService.translate('toast.problemChangePass2', {}, this.translocoService.getActiveLang()));
                                        throw new Error('could not change password...');
                                    }
                                    this.toastr.success(this.translocoService.translate('toast.successPassChanged', {}, this.translocoService.getActiveLang()));
                                    this.authService.backToLogin();
                                    return actionAccountCommandsSuccessV2({accountReply: i_payload});
                                }),
                                catchError((i_error) => {
                                    console.log(`loadRequestAccountEffect3$ ${i_error.message}`);
                                    return of(actionAccountCommandsFailure({errorMessage: i_error.message, accountReply: null}));
                                })
                            );
                        }
                        case "FORGOT_PASS": {
                            return this.userService.resetPassword(accountRequest).pipe(
                                map((i_payload: IAccountReplyV2) => {
                                    this.toastr.clear();
                                    if (i_payload.result != '1') {
                                        this.toastr.error(this.translocoService.translate('toast.probResetEmail', {}, this.translocoService.getActiveLang()));
                                        throw new Error('could not reset email...');
                                    }
                                    this.toastr.success(this.translocoService.translate('toast.passResetEmail', {}, this.translocoService.getActiveLang()));
                                    this.authService.backToLogin();
                                    return actionAccountCommandsSuccessV2({accountReply: i_payload});
                                }),
                                catchError((i_error) => {
                                    console.log(`loadRequestAccountEffect4$ ${i_error.message}`);
                                    return of(actionAccountCommandsFailure({errorMessage: i_error.message, accountReply: null}));
                                })
                            );
                        }
                        case "CREATE": {
                            // if (1) {
                            //     alert('server maintenance, please try back in an hour or so!');
                            //     return of(null);
                            // }
                            return this.userService.createAccount(accountRequest).pipe(
                                map((i_payload: IAccountReplyV2) => {
                                    if (i_payload.result == '-1') {
                                        this.toastr.clear();
                                        this.toastr.error(this.translocoService.translate('toast.accCreateFailed', {}, this.translocoService.getActiveLang()));
                                        this.authService.backToLogin();
                                        throw new Error('could not create account...');
                                    }
                                    // best-effort: record first-touch utm/referrer for this new account (see main.ts)
                                    this.userService.reportAccountAttribution(String(i_payload.businessId || ''));
                                    return i_payload as any;
                                }),
                                //// we only need this section if we bring back email verification
                                // switchMap((accountReply: IAccountReplyV2) => {
                                //   return this.userService.accountStatus(accountReply.status.result);
                                // }),
                                switchMap(() => {
                                    /** debugging social and skip create account
                                     return this.userService.getBusinessUserInfoV3('sherwin3@ms.com', '123123');
                                     **/
                                    return this.userService.getBusinessUserInfoV3(accountRequest.createCustomerAccount.userName, accountRequest.createCustomerAccount.password);
                                }),
                                map((accountReply: IUserSync) => {
                                    this.toastr.info('account created');
                                    /** debugging social and skip create account
                                     this.authService.accountCreated('sherwin3@ms.com', '123123', accountReply);
                                     **/
                                    this.authService.accountCreated(accountRequest.createCustomerAccount.userName, accountRequest.createCustomerAccount.password, accountReply);
                                    // accountReply.accountReplyV2.businessUserInfo.businessInfo.studioType
                                    return actionAccountCommandsSuccessV2({accountReply: accountReply.accountReplyV2});
                                }),
                                catchError((i_error) => {
                                    return of(actionAccountCommandsFailure({errorMessage: i_error.message, accountReply: null}));
                                })
                            );
                        }
                    }
                })
            )
        // ), {dispatch: false}
    );

    loadRequestAnnualPayerEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetAnnualPayRequest),
            switchMap((v) =>
                this.userService.getAnnualPayData(v).pipe(
                    map((i_payload: any) => actionGetAnnualPayReply({annualPayData: i_payload})),
                    catchError((i_error) => {
                        console.log(`loadRequestAnnualPayerEffect$ ${i_error.message}`);
                        return of(actionGetAnnualPayError({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadRequestAnnualPayerUpdateEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionUpdateAnnualPay),
            switchMap((v: any) =>
                this.userService.updateAnnualPayData(v).pipe(
                    map((i_payload: any) => actionUpdateAnnualPayReply({payload: i_payload})),
                    catchError((i_error) => {
                        console.log(`loadRequestAnnualPayerUpdateEffect$ ${i_error.message}`);
                        return of(actionGetAnnualPayError({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    loadRequestTemplatesEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadTemplateRequest),
            switchMap((i_templateStyle) =>
                this.userService.getTemplatesFromServer().pipe(
                    map((i_payload: any) => actionLoadTemplatesSuccess({sceneTemplateImports: i_payload})),
                    catchError((i_error) => {
                        console.log(`loadRequestTemplatesEffect$ ${i_error.message}`);
                        return of(actionLoadTemplateFailure({errorMessage: i_error.message, TemplateArray: []}));
                    })
                )
            )
        )
    );

    loadRequestCartProductsEffect$ = createEffect(() =>
            this.actions$.pipe(
                ofType(actionLoadCartProductRequest),
                switchMap((val) => {
                    return this.userService.getCartActiveProducts().pipe(
                        map((i_payload: any) => actionLoadCartProductsSuccess({cart: i_payload})),
                        catchError((i_error) => {
                            console.log(`loadRequestCartEffect$ ${i_error.message}`);
                            return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                        })
                    );
                })
            )
        // ), {dispatch: false}
    );

    loadRequestChatStats = createEffect(() =>
            this.actions$.pipe(
                ofType(actionPostChatStats),
                switchMap((val: any) => {
                    return this.userService.postChatStats(val).pipe(
                        map((i_payload: any) => actionPostChatStatsSuccess({reply: ''})),
                        catchError((i_error) => {
                            console.log(`loadRequestChatStats ${i_error.message}`);
                            return of(actionCRUDRecordFailure({saveRecord: i_error.message}));
                        })
                    );
                })
            )
        // ), {dispatch: false}
    );

    loadRequestCartContentEffect$ = createEffect(() =>
            this.actions$.pipe(
                ofType(actionLoadCartContentRequest),
                switchMap((val) => {
                    const cartRequest: ICartRequest = val.cartRequest;
                    switch (cartRequest.serverCall) {

                        case "GET_CART_CONTENT": {
                            return this.userService.getCartContent(cartRequest).pipe(
                                map((i_payload: ICartReply) => {
                                    if (!i_payload) {
                                        const c: ICartReply = {cartVersion: null, cartContent: null, cartId: null, cartLocation: null};
                                        return actionLoadCartContentSuccess({payload: c});
                                    }
                                    return actionLoadCartContentSuccess({payload: i_payload});
                                }),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "CHECKOUT_CART_WAITING": {
                            return this.userService.cartPaypalPaymentWaiting(cartRequest).pipe(
                                map((i_payload: ICartReply) => actionLoadCartPaypalTokenSuccess({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "CHECKOUT_CART_PAYPAL": {
                            return this.userService.cartPaypalPayment(cartRequest).pipe(
                                map((i_payload: ICartReply) => actionLoadCartPaypalTokenSuccess({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "CHECKOUT_CREDIT_CARD": {
                            return this.userService.cartCreditCardPayment(cartRequest).pipe(
                                map((i_payload: ICartReply) => actionCreditCardPaymentCompleted({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "ADD_CART_CONTENT_DYNAWEBS": {
                            return this.userService.cartDynawebsAddContent(cartRequest).pipe(
                                map((i_payload: ICartReply) => actionLoadDynawebsCartUpdateSuccess({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "ADD_CART_CONTENT": {
                            return this.userService.cartAddContent(cartRequest).pipe(
                                map((i_payload: ICartReply) => actionLoadCartContentSuccess({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "REMOVE_CART_CONTENT": {
                            return this.userService.cartRemoveContent(cartRequest).pipe(
                                map((i_payload: ICartReply) => actionLoadCartContentSuccess({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "REMOVE_CART_CONTENT_DYNAWEBS": {
                            return this.userService.cartRemoveDynawebsContent(cartRequest).pipe(
                                map((i_payload: ICartReply) => actionLoadDynawebsCartUpdateSuccess({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }

                        case "UPDATE_CART_SHIPPING": {
                            return this.userService.cartUpdateShipping(cartRequest).pipe(
                                map((i_payload) => actionUpdateCartShippingSuccess({payload: i_payload})),
                                catchError((i_error) => {
                                    console.log(`actionLoadCartFailure ${i_error.message}`);
                                    return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                                })
                            );
                        }
                    }
                })
            )
        // ), {dispatch: false}
    );

    saveCustomerInfoEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSaveCustomerRequest),
            switchMap((val) => {
                return this.userService.saveCustomerInfoV4(val.payload).pipe(
                    map((serverReply: IUserUpgradeReply) => {
                        if (serverReply.saved === true && serverReply.charged) {
                            this.toastr.success(serverReply.message); // saved and charged
                        } else if (serverReply.saved === true && serverReply.charged === null) {
                            this.toastr.success(serverReply.message); // saved only as intended
                        } else {
                            this.toastr.error(serverReply.message); // something went wrong
                        }
                        return actionSaveCustomerReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionSaveCustomerErrorV4  ${i_error.message}`);
                        return of(actionSaveCustomerError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    updateCustomerEmail = createEffect(() =>
        this.actions$.pipe(
            ofType(actionUpdateCustomerEmail),
            switchMap((val) => {
                return this.userService.updateCustomerEmail(val).pipe(
                    map((serverReply: any) => actionNoop({})),
                    catchError((i_error) => {
                        console.log(`updateCustomerEmail  ${i_error.message}`);
                        return of(actionSaveCustomerError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    upgradeEnterpriseEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionUserUpgradeRequest),
            switchMap((val) => {
                return this.userService.upgradeAccount(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        if (serverReply.result === true) {
                            this.toastr.success('upgrade completed successfully');
                            // todo: fix reply
                            return actionUserUpgradeReply({reply: serverReply});
                        } else {
                            return actionUserUpgradeReply({reply: serverReply});
                        }
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionUserUpgradeFailed({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );


    upgradeCustomerEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCustomerUpgradeRequest),
            switchMap((val) => {
                return this.userService.dynawebsUpgradeAccount(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        if (serverReply.result === true) {
                            this.toastr.success('upgrade completed successfully');
                        }
                        return actionCustomerUpgradeReply({reply: serverReply});
                    })
                );
            })
        )
    );

    recurringRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionRequrringsRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.result) {
                            this.toastr.success('recurrings completed successfully');
                        } else {
                            this.toastr.error(serverReply.error);
                        }
                        return actionRecurringsReply({reply: serverReply});
                    })
                );
            })
        );
    });

    getWebPlayersEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetWebPlayersRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.result) {
                            this.toastr.success('web players loaded successfully');
                        } else {
                            this.toastr.error(serverReply.error);
                        }
                        return actionGetWebPlayersReply({reply: serverReply});
                    })
                );
            })
        );
    });

    getResellerAuditEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetResellerAuditRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.result) {
                            this.toastr.success('resellers loaded successfully');
                        } else {
                            this.toastr.error(serverReply.error);
                        }
                        return actionGetResellerAuditReply({reply: serverReply});
                    })
                );
            })
        );
    });

    getStationsHistoryEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetStationsHistoryRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (!serverReply.result) {
                            this.toastr.error(serverReply.error);
                        }
                        return actionGetStationsHistoryReply({reply: serverReply});
                    })
                );
            })
        );
    });

    sharedAccountContentEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetSharedCommonContent),
            switchMap((val) => {
                return this.userService.getSharedAccountContent().pipe(
                    map((serverReply: ISharedContent[]) => {
                        return actionGetSharedCommonContentReply({value: serverReply});
                    })
                );
            })
        );
    });

    updateResellerEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionUpdateResellerRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.status) {
                            this.toastr.success('update reseller successfully');
                        } else {
                            this.toastr.error('update reseller fail');
                        }
                        return actionUpdateResellerReply({reply: serverReply});
                    })
                );
            })
        );
    });


    getBillingInfoEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetBillingInfoRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.status) {
                            this.toastr.success('get billing successfully');
                        } else {
                            this.toastr.error('get billing fail');
                        }
                        return actionGetBillingInfoReply({reply: serverReply});
                    })
                );
            })
        );
    });


    updateBillingInfoEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionUpdateBillingInfoRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.status) {
                            this.toastr.success('update billing successfully');
                        } else {
                            this.toastr.error('update billing fail');
                        }
                        return actionUpdateBillingInfoReply({reply: serverReply});
                    })
                );
            })
        );
    });


    updateRecurringRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionUpdateRequrringsRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.status) {
                            this.toastr.success('recurrings completed successfully');
                        } else {
                            this.toastr.error('recurrings update fail');
                        }
                        return actionUpdateRecurringsReply({reply: serverReply});
                    })
                );
            })
        );
    });

    detachFromResellerRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionDetachFromResellerRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        this.toastr.success('Detach from reseller successfully');
                        return actionDetachFromResellerReply({reply: serverReply});
                    })
                );
            })
        );
    });


    getResellerCustomersRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetResellerCustomersRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        this.toastr.success('get customers successfully');
                        return actionGetResellerCustomersReply({reply: serverReply});
                    })
                );
            })
        );
    });

    getCustomerUsersRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetCustomerUsersRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        this.toastr.success('get users successfully');
                        return actionGetCustomerUsersReply({reply: serverReply});
                    })
                );
            })
        );
    });

    addUserRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionAddUserRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        this.toastr.success('add user successfully');
                        return actionAddUserReply({reply: serverReply});
                    })
                );
            })
        );
    });

    deleteUserRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionDeleteUserRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        this.toastr.success('delete user successfully');
                        return actionDeleteUserReply({reply: serverReply});
                    })
                );
            })
        );
    });

    updateResetAllStationRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionRestartAllStationsRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        if (serverReply.status) {
                            this.toastr.success('reset all stations successfully');
                        } else {
                            this.toastr.error(serverReply.error);
                        }
                        return actionRestartAllStationsReply({reply: serverReply});
                    })
                );
            })
        );
    });


    getPaymentsRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetPaymentsRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        this.toastr.success('get payments successfully');
                        return actionGetPaymentsReply({reply: serverReply});
                    })
                );
            })
        );
    });

    getPaymentDetailsRequestEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionPaymentDetailsRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: IUserSaveDetailsReply) => {
                        this.toastr.success('get payment details successfully');
                        return actionPaymentDetailsReply({reply: serverReply});
                    })
                );
            })
        );
    });

    paymentUpdateEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionPaymentUpdateRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        this.toastr.success('payment update successfully');
                        return actionPaymentUpdateReply({reply: serverReply});
                    })
                );
            })
        );
    });

    paymentDeleteEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionPaymentDeleteRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        this.toastr.success('payment delete successfully');
                        return actionPaymentDeleteReply({reply: serverReply});
                    })
                );
            })
        );
    });


    getPayerLinkEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionGetPayerLinkRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        this.toastr.success('get payer link successfully');
                        return actionGetPayerLinkReply({reply: serverReply});
                    })
                );
            })
        );
    });


    paymentsReportEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actionPaymentsReportRequest),
            switchMap((val) => {
                return this.userService.getBillingService(val.payload).pipe(
                    map((serverReply: any) => {
                        this.toastr.success('payment report successfully');
                        return actionPaymentsReportReply({reply: serverReply});
                    })
                );
            })
        );
    });

    getDalleImageEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetAIImage),
            switchMap((val) => {
                return this.userService.dwDallImage(val).pipe(
                    map((serverReply: any) => {
                        return actionGetAIImageReply({payload: serverReply, url: val.prompt});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    getVeoVideoEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetAIVideo),
            switchMap((val) => {
                return this.userService.dwRunawayVideo(val).pipe(
                    map((serverReply: any) => {
                        return actionGetAIVideoReply({reply: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    feedMeAnyEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFeedMeAnyRequest),
            switchMap((val) => {
                return this.userService.feedMeAny(val.prompt, val.language, val.fields, val.series, val.dataType).pipe(
                    map((serverReply: IFeedMeAnyResponse) => {
                        return actionFeedMeAnySuccess({response: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`feedMeAnyEffect error ${i_error.message}`);
                        const errorMessage = i_error.message || 'Failed to generate feed';
                        const fullResponse = i_error.error?.fullResponse || '';
                        return of(actionFeedMeAnyFailure({errorMessage, fullResponse}));
                    })
                );
            })
        )
    );

    feedFieldsEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFeedFieldsRequest),
            switchMap((val) => {
                return this.userService.getFeedFields(val.prompt, val.language, val.numFields, val.dataType).pipe(
                    map((serverReply: IFeedFieldsResponse) => {
                        return actionFeedFieldsSuccess({response: serverReply});
                    }),
                    catchError((i_error) => {
                        const errorMessage = i_error.message || 'Failed to generate feed';
                        const fullResponse = i_error.error?.fullResponse || '';
                        return of(actionFeedFieldsFailure({errorMessage, fullResponse}));
                    })
                );
            })
        )
    );

    pollVideoStatusEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPollVideoStatus),
            switchMap((val) => {
                return this.userService.dwRunwayVideoStatus(val.taskId).pipe(
                    map((statusReply: any) => {
                        return actionPollVideoStatusReply({status: statusReply});
                    }),
                    catchError((i_error) => {
                        console.log(`pollVideoStatusEffect error ${i_error.message}`);
                        return of(actionPollVideoStatusReply({status: {error: i_error.message}}));
                    })
                );
            })
        )
    );

    getDalleImagesEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetAIImages),
            switchMap((val) => {
                return this.userService.aiImages(val).pipe(
                    map((serverReply: any) => {
                        return actionGetAIImagesReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    /**
     * Effect for AI Images V5 API - Unified OpenAI Image API
     * Supports generate, edit, and variation operations with multiple models
     */
    getAIImagesV5Effect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetAIImagesV5),
            switchMap((action) => {
                return this.userService.aiImagesV5(action.request).pipe(
                    map((serverReply: any) => {
                        if (serverReply?.error) {
                            return actionGetAIImagesV5Failure({ errorMessage: serverReply.error });
                        }
                        return actionGetAIImagesV5Reply({ payload: serverReply });
                    }),
                    catchError((i_error) => {
                        console.error(`actionGetAIImagesV5 error: ${i_error.message}`);
                        return of(actionGetAIImagesV5Failure({ errorMessage: i_error.message || 'AI image generation failed' }));
                    })
                );
            })
        )
    );

    putCustomUrlEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCustomUrl),
            switchMap((val) => {
                return this.userService.customUrl(val.payload.url, val.payload.data).pipe(
                    map((serverReply: any) => {
                        return actionCustomUrlReply({reply: ''});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    setLocalStoreConfigEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSetLocalStorageConfig),
            switchMap((val) => {
                return this.userService.dwSignSetGlobalConfig(val).pipe(
                    map((serverReply: ICartReply) => {
                        return actionSetGlobalConfigReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSaveCustomerError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    getLocalStoreConfigEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetLocalStorageConfigServer),
            switchMap((val) => {
                return this.userService.dwSignGetGlobalConfig(val).pipe(
                    map((serverReply) => {
                        try {
                            if (isNullOrUndefOrEmpty(serverReply?.config))
                                return actionNoop(null);
                            try {
                                const localStoreConfig = JSON.parse(serverReply.config);
                                return actionGetLocalStorageConfigServerReply({localStoreConfig});
                            } catch (e) {
                                return actionNoop(null);
                            }
                        } catch (e) {
                            console.log(`actionGetLocalStorageConfig ${e}`);
                        }
                    }),
                    catchError((i_error) => {
                        return actionNoop(null);
                    })
                );
            })
        )
    );

    loadPreferences$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPreferencesGet),
            mergeMap((action) => {
                return this.userService.getPreferences(action.user, action.globalService).pipe(
                    map((i_payload: any) => {
                        if (isNullOrUndefOrEmpty(i_payload.preferences)) {
                            return actionNoop(null);
                        }
                        const preferencesBusiness: IPreferencesBusiness = Lib.PreferencesProcess(i_payload.preferences);
                        this.storeSelectorsService.dispatch(actionPreferenceUpdateStore({preferencesBusiness}));
                        if (preferencesBusiness && action.checkTwoFactor && preferencesBusiness?.twoFactorState?.value?.token?.length > 10) {
                            // Only trigger 2FA lock once per session - check if already dispatched
                            if (!this._twoFactorCheckDispatched) {
                                this._twoFactorCheckDispatched = true;
                                this.storeSelectorsService.dispatch(actionTwoFactorCheckAccess({payload: preferencesBusiness.twoFactorState, status: false}));
                            }
                        }
                        return actionNoop(null);
                    }),
                    catchError((i_error) => {
                        return of(actionPreferencesError({errorMessage: false}));
                    })
                );
            })
        )
    );

    selfUpgradeEligible$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSelfUpgradeEligibleRequest),
            mergeMap((action) => {
                return this.userService.getSelfUpgradeEligible(action.businessId).pipe(
                    map((i_payload: any) => {
                        const canSelfUpgrade = i_payload?.canSelfUpgrade === true || i_payload?.canSelfUpgrade === 'true';
                        return actionSelfUpgradeEligibleReply({canSelfUpgrade});
                    }),
                    catchError(() => {
                        return of(actionSelfUpgradeEligibleReply({canSelfUpgrade: false}));
                    })
                );
            })
        )
    );

    /** Dynawebs **/

    dwOrderStatusEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsOrderStatus),
            switchMap((payload) => {
                return this.userService.orderStatusDynawebs(payload.status).pipe(
                    map((serverReply) => {
                        return actionDynawebsOrderStatusSuccess({orderForms: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwSaveServerEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsSaveServer),
            switchMap((payload) => {
                return this.userService.saveDynawebsServer(payload).pipe(
                    map((serverReply) => {
                        return actionDynawebsServerSuccess({dynawebsServer: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwSearchServerEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsSearchServer),
            switchMap((payload) => {
                return this.userService.searchDynawebsServers(payload).pipe(
                    map((serverReply) => {
                        return actionDynawebsServerSuccess({dynawebsServer: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwCreateNewOrderEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsCreateNewOrder),
            switchMap((payload) => {
                return this.userService.getDynawebsNewOrder(payload.payerId).pipe(
                    map((serverReply) => {
                        return actionDynawebsCreateNewOrderSuccess({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwCheckUserExists$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsCheckUser),
            switchMap((user) => {
                return this.userService.dwCheckUserExists(user).pipe(
                    map((serverReply) => {
                        return actionDynawebsCheckUserSuccess({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    // dwSubscriberGetPayerId$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(actionDynawebsLoadPayerIdRequest),
    //         switchMap((user) => {
    //             return this.userService.dwSubscriberGetPayerId(user).pipe(
    //                 map((payload) => {
    //                     return actionDynawebsLoadPayerIdRequestSuccess({serverReply: payload});
    //                 }),
    //                 catchError((i_error) => {
    //                     console.log(`actionLoadOrdersFailure ${i_error.message}`);
    //                     return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
    //                 })
    //             );
    //         })
    //     )
    // );

    // dwSubscriberGetBusinessId$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(actionDynawebsLoadBusinessIdRequest),
    //         switchMap((user) => {
    //             return this.userService.dwSubscriberGetBusinessId(user).pipe(
    //                 map((payload) => {
    //                     return actionDynawebsLoadBusinessIdRequestSuccess({serverReply: payload});
    //                 }),
    //                 catchError((i_error) => {
    //                     console.log(`actionLoadOrdersFailure ${i_error.message}`);
    //                     return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
    //                 })
    //             );
    //         })
    //     )
    // );

    dwGeneratePayerIdEncrypted$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsGenerateEncryptedIdRequest),
            switchMap((payload) => {
                return this.userService.dwGenerateEncryptedId(payload).pipe(
                    map((i_payload) => {
                        return actionDynawebsGenerateEncryptedIdReply({serverReply: i_payload});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwCartGetOrderIdEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetOrderIdRequest),
            switchMap((val) => {
                return this.userService.dwCartGetOrderId(val.cartRequest).pipe(
                    map((serverReply: ICartReply) => {
                        return actionGetOrderIdSuccess({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwTextToSpeechCreateEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionTextToSpeechCreateSend),
            switchMap((val) => {
                return this.userService.dwTextToSpeechCreate(val.payload).pipe(
                    map((serverReply: any) => {
                        return actionTextToSpeechCreateReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionTextToSpeechUploadError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwTextToSpeechUploadEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionTextToSpeechUploadSend),
            switchMap((val) => {
                return this.userService.dwTextToSpeechUpload(val.payload).pipe(
                    map((serverReply: any) => {
                        return actionTextToSpeechUploadReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionTextToSpeechUploadError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwSetStudioTypeEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsSetStudioTypeSend),
            switchMap((val) => {
                return this.userService.dwSetStudioType(val.payload).pipe(
                    map((serverReply: any) => {
                        return actionDynawebsSetStudioTypeReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionDynawebsSetStudioTypeError ${i_error.message}`);
                        return of(actionDynawebsSetStudioTypeError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwRevertMigrationEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsRevertMigrationSend),
            switchMap((val) => {
                return this.userService.dwRevertMigration(val.payload).pipe(
                    map((serverReply: any) => {
                        return actionDynawebsRevertMigrationReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionDynawebsRevertMigrationError ${i_error.message}`);
                        return of(actionDynawebsRevertMigrationError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwGetMigratedAccountsEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsGetMigratedAccountsSend),
            switchMap(() => {
                return this.userService.dwGetMigratedAccounts().pipe(
                    map((serverReply: any) => {
                        return actionDynawebsGetMigratedAccountsReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionDynawebsGetMigratedAccountsError ${i_error.message}`);
                        return of(actionDynawebsGetMigratedAccountsError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwFreeLoadersRunSearchEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFreeLoadersRunSearch),
            switchMap((val) =>
                this.userService.dwFreeLoadersRunSearch(val.max).pipe(
                    map((r: any) => actionFreeLoadersRunSearchReply({runId: r.runId || ''})),
                    catchError((e) => of(actionFreeLoadersRunSearchError({errorMessage: e.message})))
                )
            )
        )
    );

    dwFreeLoadersRunIPEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFreeLoadersRunIP),
            switchMap(() =>
                this.userService.dwFreeLoadersRunIP().pipe(
                    map((r: any) => actionFreeLoadersRunIPReply({runId: r.runId || ''})),
                    catchError((e) => of(actionFreeLoadersRunIPError({errorMessage: e.message})))
                )
            )
        )
    );

    dwFreeLoadersDomainRunEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFreeLoadersDomainRun),
            switchMap((val) =>
                this.userService.dwFreeLoadersDomainRun(val.domain).pipe(
                    map((r: any) => actionFreeLoadersDomainRunReply({runId: r.runId || '', domain: r.domain || val.domain})),
                    catchError((e) => of(actionFreeLoadersDomainRunError({errorMessage: e.message})))
                )
            )
        )
    );

    dwFreeLoadersStatusEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionFreeLoadersStatus),
            exhaustMap((val) =>
                this.userService.dwFreeLoadersStatus(val.runId).pipe(
                    map((r: any) => actionFreeLoadersStatusReply({payload: r})),
                    catchError((e) => of(actionFreeLoadersStatusError({errorMessage: e.message})))
                )
            )
        )
    );

    dwMoveAccountEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsMoveAccountSend),
            switchMap((val) => {
                return this.userService.dwMoveAccount(val.payload).pipe(
                    map((serverReply: any) => {
                        return actionDynawebsMoveAccountReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.error(`actionDynawebsMoveAccountError ${i_error.message}`);
                        return of(actionDynawebsMoveAccountError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwAwakeSetEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsAwakeSet),
            switchMap((val) =>
                this.userService.dwAwakeSet(val.value).pipe(
                    map((r: any) => actionDynawebsAwakeSetReply({payload: r})),
                    catchError((e) => of(actionDynawebsAwakeSetError({errorMessage: e.message})))
                )
            )
        )
    );

    dwAwakeGetEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsAwakeGet),
            switchMap(() =>
                this.userService.dwAwakeGet().pipe(
                    map((r: any) => actionDynawebsAwakeGetReply({payload: r})),
                    catchError((e) => of(actionDynawebsAwakeGetError({errorMessage: e.message})))
                )
            )
        )
    );

    dwCartGetBusinessUsage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsBusinessUsage),
            switchMap((val) => {
                return this.userService.dwGetBusinessUsage(val).pipe(
                    map((serverReply) => {
                        return actionDynawebsBusinessUsageReply({businessUsage: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );


    dwSaveCustomerInfoEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSaveCustomerDynawebsInfo),
            switchMap((val) => {
                return this.userService.saveCustomerDynawebsInfo(val.payload).pipe(
                    map((serverReply: ICartReply) => {
                        return actionSaveCustomerDynawebsReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSaveCustomerDynawebsError({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwSaveEquipmentSaveEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSaveDynawebsEquipment),
            switchMap((val) => {
                return this.userService.saveEquipment(val.payload).pipe(
                    map((serverReply: any) => {
                        return actionSaveDynawebsEquipmentSuccess({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSaveFailedDynawebsEquipment({payload: i_error.message}));
                    })
                );
            })
        )
    );

    dwLoadEquipmentLoadEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadDynawebsEquipment),
            switchMap((val) => {
                return this.userService.loadEquipment(val.payload).pipe(
                    map((serverReply: any) => {
                        return actionLoadDynawebsEquipmentReply({payload: serverReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadDynawebsEquipmentReply({payload: i_error.message}));
                    })
                );
            })
        )
    );

    dwLoadOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadDynawebsOrder),
            switchMap((val: { dwLoad: directionType, orderId: number }) => {
                return this.userService.dwLoadCustomer(val).pipe(
                    map((order: IOrderForm) => {
                        return actionLoadDynawebsOrderReply({order});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwFindOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsFindOrder),
            switchMap((val) => {
                return this.userService.dwFindOrder(val.payload).pipe(
                    map((orders) => {
                        return actionDynawebsFindOrderSuccess({orderForms: orders});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwFindCustomer$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsFindCustomer),
            switchMap((val) => {
                return this.userService.dwFindCustomer(val.dynawebsServer).pipe(
                    map((orders) => {
                        return actionDynawebsFindCustomerSuccess({orderForms: orders});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwRenameCustomer$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsRenameCustomer),
            switchMap((val) => {
                return this.userService.dwRenameCustomer(val).pipe(
                    map((resp: any) => {
                        // mars /dwRenameUser replies {results: boolean, payload: {...}}; results === false means galaxy
                        // refused the rename (old user missing / new user taken) or the call to galaxy failed
                        if (resp && resp.results === false) {
                            const reason = resp.payload && resp.payload.error ? resp.payload.error : 'unknown error';
                            const {oldUser, newUser} = val.credentials || {} as any;
                            this.toastr.error(`rename ${oldUser} -> ${newUser} was NOT applied: ${reason}`);
                            return actionLoadCartFailure({errorMessage: String(reason), cart: null});
                        }
                        return actionDynawebsRenameCustomerSuccess({credentials: val});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwDeleteOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsDeleteOrder),
            switchMap((val) => {
                return this.userService.dwDeleteOrder(val.orderId).pipe(
                    map((order: IOrderForm) => {
                        return actionDynawebsDeleteOrderCompleted('');
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwLoadCartOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionLoadDynawebsCart),
            switchMap((val) => {
                return this.userService.dwCartGetContent(val.cartRequest).pipe(
                    map((cart) => {
                        return actionLoadDynawebsCartReply({cart});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionLoadCartFailure({errorMessage: i_error.message, cart: null}));
                    })
                );
            })
        )
    );

    dwGetChatArchive$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPostChatArchive),
            switchMap((val) => {
                return this.userService.dwGetChatArchive(val).pipe(
                    map((v) => {
                        return actionPostChatArchiveReply({payload: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionPostChatArchiveFailed({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwGetChatArchiveSearch$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPostChatArchiveSearch),
            switchMap((val) => {
                return this.userService.dwGetChatArchiveSearch(val).pipe(
                    map((v) => {
                        return actionPostChatArchiveSearchReply({payload: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionPostChatArchiveFailed({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwGetPayerReports$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsGetPayerReports),
            switchMap((val) => {
                return this.userService.dwReportSubscribers(val).pipe(
                    map((v) => {
                        return actionDynawebsGetPayerReportsReply({payload: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionPostChatArchiveFailed({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwReportPayers = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsGetPayerReport),
            switchMap((val) => {
                return this.userService.dwReportPayers(val).pipe(
                    map((v) => {
                        return actionDynawebsGetPayerReportReply({payload: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionPostChatArchiveFailed({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwReportNonPayers = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsGetNonPayerReport),
            switchMap((val) => {
                return this.userService.dwReportNonPayers(val).pipe(
                    map((v) => {
                        return actionDynawebsGetNonPayerReportReply({payload: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionPostChatArchiveFailed({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwGetAccountDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDynawebsGetAccDetails),
            switchMap((val) => {
                return this.userService.dwGetAccountDetails(val.payload.business).pipe(
                    map((v) => {
                        return actionDynawebsGetAccDetailsReply({payload: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionPostChatArchiveFailed({errorMessage: i_error.message}));
                    })
                );
            })
        )
    );

    dwRequestCartProductsEffect$ = createEffect(() =>
            this.actions$.pipe(
                ofType(actionLoadDynawebsCartProductRequest),
                switchMap((val) => {
                    return this.userService.getDynawebsProducts().pipe(
                        map((i_payload: any) => actionLoadDynawebsCartProductsSuccess({products: i_payload})),
                        catchError((i_error) => {
                            console.log(`loadRequestCartEffect$ ${i_error.message}`);
                            return of(actionLoadCartFailure({errorMessage: i_error.message, cart: []}));
                        })
                    );
                })
            )
        // ), {dispatch: false}
    );

    actionUploadFilesEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionUploadFiles),
            switchMap((val) => {
                return this.userService.crudRecord(val.saveRecord).pipe(
                    map((i_reply: ICRUDRecordReply) => {
                        let command;
                        const fileObj = val.file;
                        if (i_reply && i_reply.hasOwnProperty('type') && (i_reply.hasOwnProperty('status') == false || i_reply.hasOwnProperty('body') == false)) {
                            command = "progress";
                        } else {
                            command = "reply";
                        }

                        if (command == 'progress') {
                            if (i_reply['type'] == '1' && i_reply['total']) {
                                const percent = Math.round(100 * parseFloat(i_reply['loaded']) / parseFloat(i_reply['total']));
                                if (percent < 100) {
                                    fileObj.progress = percent;
                                } else {
                                    fileObj.progress = 100;
                                }
                            }
                            fileObj.uploadStatus = UploadStatus.INPROGRESS;
                        } else {
                            if (!i_reply.status) {
                                fileObj.progress = 0;
                                fileObj.uploadStatus = UploadStatus.FAILED;
                            } else {
                                fileObj.progress = 100;
                                fileObj.uploadStatus = UploadStatus.SUCCESS;
                                if (i_reply['body'] && i_reply['body'].id) {
                                    fileObj.fileId = i_reply['body'].id;
                                }
                            }
                        }
                        val.saveRecord.serverReply = i_reply;
                        return actionUploadFilesReply({payload: val.saveRecord, file: fileObj});
                    }),
                    catchError((i_error) => {
                        return of(actionCRUDRecordFailure({
                            saveRecord: {
                                studioId: null,
                                command: "reply",
                                body: i_error,
                                serverReply: {status: false, id: null}
                            }
                        }));
                    })
                );
            })
        )
    );

    actionCreateSocialProfileId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSocialCreateKey),
            switchMap((val) => {
                return this.userService.createSocialServiceProfile().pipe(
                    map((socialReply: ISocialReply) => {
                        return actionSocialCreateSuccess({socialReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSocialCreateError({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionPostSocial$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSocialPost),
            switchMap((val) => {
                return this.userService.postSocialServiceProfile(val).pipe(
                    map((socialReply: ISocialReply) => actionSocialPostSuccess({socialReply})),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSocialCreateError({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionLoadSocialConnections$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSocialCreateURL),
            switchMap((val) => {
                return this.userService.createSocialCreateURL(val.socialKey).pipe(
                    map((socialReply: ISocialReply) => {
                        return actionSocialCreateURLSuccess({socialReply});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSocialCreateError({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionCanvaAuthorize$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCanvaAuthorizeRequest),
            switchMap((val) => {
                return this.userService.authorizeCanva().pipe(
                    map((response: any) => {
                        return actionCanvaAuthorizeSuccess({response});
                    }),
                    catchError((i_error) => {
                        console.log(`actionCanvaAuthorizeFailure ${i_error.message}`);
                        return of(actionCanvaAuthorizeFailure({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionCanvaGetRefId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCanvaGetRefIdRequest),
            switchMap((val) => {
                return this.userService.getCanvaRefId().pipe(
                    map((response: any) => {
                        return actionCanvaGetRefIdSuccess({response});
                    }),
                    catchError((i_error) => {
                        console.log(`actionCanvaGetRefIdFailure ${i_error.message}`);
                        return of(actionCanvaGetRefIdFailure({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionCanvaRevoke$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCanvaRevokeRequest),
            switchMap((val) => {
                return this.userService.revokeCanvaAuth(val.refId).pipe(
                    map((response: any) => {
                        return actionCanvaRevokeSuccess({response});
                    }),
                    catchError((i_error) => {
                        console.log(`actionCanvaRevokeFailure ${i_error.message}`);
                        return of(actionCanvaRevokeFailure({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionTwoFactorGen$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionTwoFactorGen),
            switchMap((val) => {
                return this.userService.twoFactorGen().pipe(
                    map((v: any) => {
                        return actionTwoFactorGenReply({replay: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionTwoFactorGenError({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionTwoFactorSave$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionTwoFactorAuth),
            switchMap((val) => {
                return this.userService.twoFactorAuth(val).pipe(
                    map((v: any) => {
                        return actionTwoFactorAuthReply({replay: v});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionTwoFactorAuthError({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionSocialRemoveKey$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSocialRemoveKey),
            switchMap((val: any) => {
                return this.userService.loadSocialRemoveKey(val).pipe(
                    map((socialReply: ISocialReply) => {
                        if (socialReply.status === 'success') {
                            return actionSocialRemoveKeySuccess({socialReply});
                        } else {
                            return actionSocialRemoveKeyError({});
                        }
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSocialCreateError({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    actionSocialRemoveKeyWithBusinessId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionSocialRemoveKeyWithBusinessId),
            switchMap((val) => {
                return this.userService.loadSocialRemoveKeyWithBusinessId().pipe(
                    map((socialReply: ISocialReply) => {
                        return actionSocialRemoveKeyWithBusinessIdSuccess({});
                    }),
                    catchError((i_error) => {
                        console.log(`actionLoadOrdersFailure ${i_error.message}`);
                        return of(actionSocialCreateError({errorMessage: i_error?.message}));
                    })
                );
            })
        )
    );

    // actionUpdateSceneItemGroupEffect$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(actionUpdateSceneItemGroup),
    //         switchMap((v) => of(new actionCRUDScene(v)))
    //     )
    // );

    // Pexels Search Photos Effect
    pexelsSearchPhotosEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPexelsSearchPhotos),
            map((action) => action),
            switchMap((action) =>
                this.userService.pexelsSearchPhotos(action.query, action.perPage, action.page, action.download).pipe(
                    map((payload) => actionPexelsSearchPhotosReply({payload})),
                    catchError((error) => {
                        console.error('Pexels search photos error:', error);
                        return of(actionPexelsSearchPhotosReply({payload: {error: error.message || 'Unknown error'}}));
                    })
                )
            )
        )
    );

    // Pexels Search Videos Effect
    pexelsSearchVideosEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPexelsSearchVideos),
            map((action) => action),
            switchMap((action) =>
                this.userService.pexelsSearchVideos(action.query, action.perPage, action.page, action.download, action.quality).pipe(
                    map((payload) => actionPexelsSearchVideosReply({payload})),
                    catchError((error) => {
                        console.error('Pexels search videos error:', error);
                        return of(actionPexelsSearchVideosReply({payload: {error: error.message || 'Unknown error'}}));
                    })
                )
            )
        )
    );

    /** AI Scene Generator */
    generateAISceneEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGenerateAISceneRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.generateAIScene(action.prompt, action.engine).pipe(
                    map((response) => actionGenerateAISceneReply({response})),
                    catchError((error) => {
                        console.error('AI scene generation error:', error);
                        return of(actionGenerateAISceneFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Network Builder live ping — mergeMap so a slow (timed-out) ping
     *  can't cancel a faster in-flight one. With 3s cadence + 2s timeout
     *  overlap is rare anyway, but mergeMap is the safest default. */
    pingStationEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionPingStationRequest),
            mergeMap((action) =>
                this.userService.pingStation(action.ip, action.stationBusinessId).pipe(
                    map((response) => actionPingStationReply({response})),
                    catchError((error) => of(actionPingStationFailure({
                        errorMessage: error?.message || 'ping failed',
                        stationBusinessId: action.stationBusinessId,
                    }))),
                ),
            ),
        ),
    );

    /** AI Scene Refinement */
    refineAISceneEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionRefineAISceneRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.refineAIScene(action.scene, action.refinement, action.conversationHistory).pipe(
                    map((response) => actionRefineAISceneReply({response})),
                    catchError((error) => {
                        console.error('AI scene refinement error:', error);
                        return of(actionRefineAISceneFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** AI Scene Variations */
    generateAISceneVariationsEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGenerateAISceneVariationsRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.generateAISceneVariations(action.prompt, action.variationCount).pipe(
                    map((response) => actionGenerateAISceneVariationsReply({response})),
                    catchError((error) => {
                        console.error('AI scene variations error:', error);
                        return of(actionGenerateAISceneVariationsFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** AI Paint Generation */
    generateAIPaintEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGenerateAIPaintRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.generateAIPaint(action.prompt, action.width, action.height).pipe(
                    map((response) => actionGenerateAIPaintReply({response})),
                    catchError((error) => {
                        console.error('AI paint generation error:', error);
                        return of(actionGenerateAIPaintFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Remotion Video */
    remotionVideoEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionRemotionVideoRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.dwRemotionVideo({ prompt: action.prompt, images: action.images, videos: action.videos, engine: action.engine }).pipe(
                    map((response) => actionRemotionVideoReply({ response })),
                    catchError((error) => {
                        console.error('Remotion video error:', error);
                        return of(actionRemotionVideoFailure({ errorMessage: error.message || 'Unknown error' }));
                    })
                )
            )
        )
    );

    remotionVideoStatusEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionRemotionVideoStatusRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.dwRemotionVideoStatus(action.taskId).pipe(
                    map((response) => actionRemotionVideoStatusReply({ response })),
                    catchError((error) => {
                        console.error('Remotion video status error:', error);
                        return of(actionRemotionVideoStatusFailure({ errorMessage: error.message || 'Unknown error' }));
                    })
                )
            )
        )
    );

    remotionVideoEditEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionRemotionVideoEditRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.dwRemotionVideoEdit({ taskId: action.taskId, prompt: action.prompt, images: action.images, videos: action.videos }).pipe(
                    map((response) => actionRemotionVideoEditReply({ response })),
                    catchError((error) => {
                        console.error('Remotion video edit error:', error);
                        return of(actionRemotionVideoEditFailure({ errorMessage: error.message || 'Unknown error' }));
                    })
                )
            )
        )
    );

    // ========================================
    // TICKET SYSTEM EFFECTS
    // ========================================

    /** Create Ticket */
    createTicketEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCreateTicketRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.createTicket(action.payload).pipe(
                    map((payload) => actionCreateTicketReply({payload})),
                    catchError((error) => {
                        console.error('Create ticket error:', error);
                        return of(actionCreateTicketFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Get Tickets List */
    getTicketsEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetTicketsRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.getTickets(action.payload).pipe(
                    map((payload) => actionGetTicketsReply({payload})),
                    catchError((error) => {
                        console.error('Get tickets error:', error);
                        return of(actionGetTicketsFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Get Single Ticket */
    getTicketEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetTicketRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.getTicket(action.ticketId).pipe(
                    map((payload) => actionGetTicketReply({payload})),
                    catchError((error) => {
                        console.error('Get ticket error:', error);
                        return of(actionGetTicketFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Update Ticket */
    updateTicketEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionUpdateTicketRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.updateTicket(action.payload).pipe(
                    map((payload) => actionUpdateTicketReply({payload})),
                    catchError((error) => {
                        console.error('Update ticket error:', error);
                        return of(actionUpdateTicketFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Add Ticket Message */
    addTicketMessageEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionAddTicketMessageRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.addTicketMessage(action.payload).pipe(
                    map((payload) => actionAddTicketMessageReply({payload})),
                    catchError((error) => {
                        console.error('Add ticket message error:', error);
                        return of(actionAddTicketMessageFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Close Ticket */
    closeTicketEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionCloseTicketRequest),
            map((action) => action),
            switchMap((action) =>
                this.userService.closeTicket(action.payload).pipe(
                    map((payload) => actionCloseTicketReply({payload})),
                    catchError((error) => {
                        console.error('Close ticket error:', error);
                        return of(actionCloseTicketFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Get Ticket Stats */
    getTicketStatsEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetTicketStatsRequest),
            switchMap(() =>
                this.userService.getTicketStats().pipe(
                    map((payload) => actionGetTicketStatsReply({payload})),
                    catchError((error) => {
                        console.error('Get ticket stats error:', error);
                        return of(actionGetTicketStatsFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Get Customer Ticket (no auth required) */
    getCustomerTicketEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetCustomerTicketRequest),
            map((action) => action.payload),
            switchMap((payload) =>
                this.userService.getCustomerTicket(payload).pipe(
                    map((response) => actionGetCustomerTicketReply({payload: response})),
                    catchError((error) => {
                        console.error('Get customer ticket error:', error);
                        return of(actionGetCustomerTicketFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Add Customer Ticket Message (no auth required) */
    addCustomerTicketMessageEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionAddCustomerTicketMessageRequest),
            map((action) => action.payload),
            switchMap((payload) =>
                this.userService.addCustomerTicketMessage(payload).pipe(
                    map((response) => actionAddCustomerTicketMessageReply({payload: response})),
                    catchError((error) => {
                        console.error('Add customer ticket message error:', error);
                        return of(actionAddCustomerTicketMessageFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Get Canned Responses */
    getCannedResponsesEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionGetCannedResponsesRequest),
            map((action) => action.category),
            switchMap((category) =>
                this.userService.getCannedResponses(category).pipe(
                    map((response) => actionGetCannedResponsesReply({payload: response})),
                    catchError((error) => {
                        console.error('Get canned responses error:', error);
                        return of(actionGetCannedResponsesFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Add Canned Response */
    addCannedResponseEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionAddCannedResponseRequest),
            map((action) => action.payload),
            switchMap((payload) =>
                this.userService.addCannedResponse(payload).pipe(
                    map((response) => actionAddCannedResponseReply({payload: response})),
                    catchError((error) => {
                        console.error('Add canned response error:', error);
                        return of(actionAddCannedResponseFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Update Canned Response */
    updateCannedResponseEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionUpdateCannedResponseRequest),
            map((action) => action.payload),
            switchMap((payload) =>
                this.userService.updateCannedResponse(payload).pipe(
                    map((response) => actionUpdateCannedResponseReply({payload: response})),
                    catchError((error) => {
                        console.error('Update canned response error:', error);
                        return of(actionUpdateCannedResponseFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /** Delete Canned Response */
    deleteCannedResponseEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDeleteCannedResponseRequest),
            map((action) => action.payload),
            switchMap((payload) =>
                this.userService.deleteCannedResponse(payload).pipe(
                    map((response) => actionDeleteCannedResponseReply({payload: response})),
                    catchError((error) => {
                        console.error('Delete canned response error:', error);
                        return of(actionDeleteCannedResponseFailure({errorMessage: error.message || 'Unknown error'}));
                    })
                )
            )
        )
    );

    /**
     * Monitor Wall v2 — mars /monitorWall/* (roadmap M2)
     *
     * IMPORTANT: these effects use mergeMap (not switchMap) so concurrent
     * callers don't cancel each other's HTTP requests (see bug audit C-02).
     * Each request's corrId is echoed on the reply/failure so callers can
     * demultiplex via MonitorApiService.oneShot filter.
     */
    monitorMintTokenEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorMintTokenRequest),
            mergeMap((action) =>
                this.userService.monitorMintToken(action.studioId).pipe(
                    map((reply: any) => actionMonitorMintTokenReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorMintTokenFailure({errorMessage: error?.message || 'mintToken error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorRedeemTokenEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorRedeemTokenRequest),
            mergeMap((action) =>
                this.userService.monitorRedeemToken(action.token).pipe(
                    map((reply: any) => actionMonitorRedeemTokenReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorRedeemTokenFailure({errorMessage: error?.message || 'redeemToken error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorPostEventsEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorPostEventsRequest),
            mergeMap((action) =>
                this.userService.monitorPostEvents(action.events).pipe(
                    map((reply: any) => actionMonitorPostEventsReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorPostEventsFailure({errorMessage: error?.message || 'postEvents error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorRefreshIdentitiesEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorRefreshIdentitiesRequest),
            mergeMap((action) =>
                this.userService.monitorRefreshIdentities(action.items).pipe(
                    map((reply: any) => actionMonitorRefreshIdentitiesReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorRefreshIdentitiesFailure({errorMessage: error?.message || 'refreshIdentities error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorGetFeedEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorGetFeedRequest),
            mergeMap((action) =>
                this.userService.monitorGetFeed(action.sinceMs, action.limit).pipe(
                    map((reply: any) => actionMonitorGetFeedReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorGetFeedFailure({errorMessage: error?.message || 'getFeed error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorGetHistoryEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorGetHistoryRequest),
            mergeMap((action) =>
                this.userService.monitorGetHistory(action.stationBusinessId, action.hours).pipe(
                    map((reply: any) => actionMonitorGetHistoryReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorGetHistoryFailure({errorMessage: error?.message || 'getHistory error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorAckEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorAckRequest),
            mergeMap((action) =>
                this.userService.monitorAck(action.eventId).pipe(
                    map((reply: any) => actionMonitorAckReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorAckFailure({errorMessage: error?.message || 'ack error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorStreamTicketEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorStreamTicketRequest),
            mergeMap((action) =>
                this.userService.monitorStreamTicket().pipe(
                    map((reply: any) => actionMonitorStreamTicketReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorStreamTicketFailure({errorMessage: error?.message || 'streamTicket error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorGetConfigEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorGetConfigRequest),
            mergeMap((action) =>
                this.userService.monitorGetConfig().pipe(
                    map((reply: any) => actionMonitorGetConfigReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorGetConfigFailure({errorMessage: error?.message || 'getConfig error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorPutConfigEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorPutConfigRequest),
            mergeMap((action) =>
                this.userService.monitorPutConfig(action.config).pipe(
                    map((reply: any) => actionMonitorPutConfigReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorPutConfigFailure({errorMessage: error?.message || 'putConfig error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorGetStatesEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorGetStatesRequest),
            mergeMap((action) =>
                this.userService.monitorGetStates().pipe(
                    map((reply: any) => actionMonitorGetStatesReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorGetStatesFailure({errorMessage: error?.message || 'getStates error', corrId: action.corrId})))
                )
            )
        )
    );

    /**
     * MonitorService (mars cron) effects — back the 4 /monitorService/* endpoints.
     */
    monitorServiceGetConfigEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorServiceGetConfigRequest),
            mergeMap((action) =>
                this.userService.monitorServiceGetConfig().pipe(
                    map((reply: any) => actionMonitorServiceGetConfigReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorServiceGetConfigFailure({errorMessage: error?.message || 'getBusinessConfig error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorServiceSetConfigEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorServiceSetConfigRequest),
            mergeMap((action) =>
                this.userService.monitorServiceSetConfig({enabled: action.enabled, pollMinutes: action.pollMinutes}).pipe(
                    map((reply: any) => actionMonitorServiceSetConfigReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorServiceSetConfigFailure({errorMessage: error?.message || 'setBusinessConfig error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorServiceAddStationEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorServiceAddStationRequest),
            mergeMap((action) =>
                this.userService.monitorServiceAddStation(action.stationBusinessId).pipe(
                    map((reply: any) => actionMonitorServiceAddStationReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorServiceAddStationFailure({errorMessage: error?.message || 'addStation error', corrId: action.corrId})))
                )
            )
        )
    );

    monitorServiceRemoveStationEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionMonitorServiceRemoveStationRequest),
            mergeMap((action) =>
                this.userService.monitorServiceRemoveStation(action.stationBusinessId).pipe(
                    map((reply: any) => actionMonitorServiceRemoveStationReply({reply, corrId: action.corrId})),
                    catchError((error) => of(actionMonitorServiceRemoveStationFailure({errorMessage: error?.message || 'removeStation error', corrId: action.corrId})))
                )
            )
        )
    );

    dwGetStoppedPlayersEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDwGetStoppedPlayersRequest),
            switchMap(() =>
                this.userService.dwGetStoppedPlayers().pipe(
                    map((serverReply: any) => actionDwGetStoppedPlayersReply({payload: serverReply})),
                    catchError((i_error) => {
                        console.log(`actionDwGetStoppedPlayersFailure ${i_error.message}`);
                        return of(actionDwGetStoppedPlayersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    dwSaveStoppedPlayersEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actionDwSaveStoppedPlayersRequest),
            exhaustMap((val) =>
                this.userService.dwSaveStoppedPlayers(val.ids).pipe(
                    map((serverReply: any) => actionDwSaveStoppedPlayersReply({payload: serverReply})),
                    catchError((i_error) => {
                        console.log(`actionDwSaveStoppedPlayersFailure ${i_error.message}`);
                        return of(actionDwSaveStoppedPlayersFailure({errorMessage: i_error.message}));
                    })
                )
            )
        )
    );

    private appSettings: IAppStatic;

    constructor(private storeSelectorsService: StoreSelectorsService,
                private router: Router,
                private userService: UserService,
                private localStorage: LocalStoreService,
                private actions$: Actions,
                private toastr: ToastrService,
                private translocoService: TranslocoService,
                private authService: AuthUserService) {

        storeSelectorsService.getAppSettings()
            .subscribe((appSettings: IAppStatic) => {
                this.appSettings = appSettings;
            });
    }
}
